class SdHeaderComponent extends HTMLElement {
  #lastScrollY = 0;
  #scrollRafId = null;

  #resizeObserver = new ResizeObserver(([entry]) => {
    if (!entry?.borderBoxSize[0]) return;
    const height = Math.round(entry.borderBoxSize[0].blockSize);
    document.body.style.setProperty('--header-height', `${height}px`);
  });

  #handleScroll = () => {
    if (this.#scrollRafId !== null) return;
    this.#scrollRafId = requestAnimationFrame(() => {
      this.#scrollRafId = null;
      this.#updateScrollState();
    });
  };

  #updateScrollState() {
    const scrollY = window.scrollY;
    const isAtTop = scrollY <= 10;

    if (isAtTop) {
      this.dataset.stickyState = 'inactive';
      this.dataset.scrollDirection = 'none';
    } else if (scrollY < this.#lastScrollY) {
      this.dataset.stickyState = 'active';
      this.dataset.scrollDirection = 'up';
    } else {
      this.dataset.stickyState = 'active';
      this.dataset.scrollDirection = 'down';
    }

    this.#lastScrollY = scrollY;
  }

  #measureMenuTextWidths() {
    const menuItems = this.querySelectorAll('.header--menu__list-item');
    for (const item of menuItems) {
      const textSpan = item.querySelector('.header--menu__list-link-title');
      const link = item.querySelector('.header--menu__list-link');
      if (textSpan && link) {
        link.style.setProperty('--text-width', `${textSpan.scrollWidth}px`);
      }
    }
  }

  #measureSubmenuHeight() {
    const submenuItems = this.querySelectorAll('.header--menu__list-submenu');

    for (const submenu of submenuItems) {
      const height = submenu.scrollHeight;
      submenu.style.setProperty('--submenu-height', `${height}px`);
    }
  }
  #menuHoverListener() {
    this.querySelectorAll('.header--menu__list-item').forEach((item) => {
      const submenu = item.querySelector('.header--menu__list-submenu');
      if (!submenu) return;
    
      item.addEventListener('mouseenter', () => {
        const height = submenu.scrollHeight;
        this.style.setProperty('--submenu-height', `${height}px`);
      });
      item.addEventListener('mouseleave', () => {
        this.style.setProperty('--submenu-height', '0px');
      });
    });
  }

  connectedCallback() {
    this.#resizeObserver.observe(this);
    document.addEventListener('scroll', this.#handleScroll);
    this.#measureMenuTextWidths();
    this.#measureSubmenuHeight();
    this.#menuHoverListener();
  }

  disconnectedCallback() {
    this.#resizeObserver.disconnect();
    document.removeEventListener('scroll', this.#handleScroll);
    if (this.#scrollRafId !== null) {
      cancelAnimationFrame(this.#scrollRafId);
      this.#scrollRafId = null;
    }
    document.body.style.setProperty('--header-height', '0px');
  }
}

if (!customElements.get('sd-header-component')) {
  customElements.define('sd-header-component', SdHeaderComponent);
}